// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3B2XT","title":"AfterBackImages_title__1PJcz","images":"AfterBackImages_images__3DgD7"};